import React, { useContext } from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import FeedThumb from '../_partials/FeedThumb';

import s from './Feed.scss';

export interface Props {
  items: PapiDeviation[];
  profileOwnerUser: PapiUser;
  isOwner?: boolean;
}

const FeedWidget: React.FC<Props> = ({ items }) => {
  const isMobile = useContext(MobileContext);
  const post_comment_suggestions = useFlag('post_comment_suggestions');
  const RootComponent: any = isMobile ? SwipeSlider : 'div';

  return (
    <RootComponent className={s['root']}>
      {items.map((item: PapiDeviation, i: number) => (
        <BiLoggerContextProvider
          key={`${item.typeId}-${item.deviationId}`}
          value={{ rank: i, sectionname: 'postsfeed_widget' }}
        >
          <FeedThumb
            deviation={item}
            className={s['item']}
            withComments
            withCommentSuggestions={
              post_comment_suggestions ? 'posts' : undefined
            }
          />
        </BiLoggerContextProvider>
      ))}
    </RootComponent>
  );
};

export default FeedWidget;
